import { isObject } from 'lodash';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

export class BaseModel {
  static columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static associationMap = new Map<
    string,
    { property: string; model: string; type: 'association' }
  >();
  static aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static isColumn(property: string) {
    return this.columnMap.has(property);
  }

  static isAlias(property: string) {
    return this.aliasedColumnMap.has(property);
  }

  static isAssociation(property: string) {
    return this.associationMap.has(property);
  }

  static isJSONColumn(property: string) {
    const column = this.columnMap.get(property);

    if (!isObject(column)) {
      return false;
    }

    const { dataType } = column;

    return dataType === 'JSON';
  }
}
